import { createPopper  } from '@popperjs/core';
import { whenDocumentReady } from '../../../../../paws/assets/frontend/js/helper/documentready';

whenDocumentReady(initModule);

function GetChildren(element, allElements) {
    let invalidTags = ['H1', 'H2', 'H3', 'H4', 'H5', 'H6', 'A', 'BUTTON'];
    let children = element.children;
    if (children !== undefined && children.length > 0) {
        for (let i = 0; i < children.length; i++) {
            if (!children[i].classList.contains('glossaryignore') && !invalidTags.includes(element.tagName)) {
                allElements = GetChildren(children[i], allElements);
            }
        }
    }
    else {
        allElements.push(element);
    }
    return allElements;
}

function ProcessGlossary(allElements, wordlist) {
    for (let k = 0; k < allElements.length; k++) {
        for (let i = 0; i < wordlist.length; i++) {
            let obj = wordlist[i];

            let rx;
            let rxType;
            if (obj.behavior.includes('standalone') || obj.text.trim().indexOf(' ') >= 0) {
                rx = '\\b' + obj.text.trim() + '+\\b|\\b' + obj.text.trim() + '[äöüÄÖÜéèàÉÈÀç]+\\b';
                rxType = '1';
            }
            else if (obj.behavior.includes('padleft') && obj.behavior.includes('padright')) {
                rx = '\\b(?=[\\wäöüÄÖÜéèàÉÈÀç]*' + obj.text.trim() + ')[\\wäöüÄÖÜéèàÉÈÀç]+\\b';
                rxType = '2';
            }
            else if (obj.behavior.includes('padright')) {
                rx = '(' + obj.text.trim() + '.*?)([?^\\s.,]+)';
                rxType = '4';
            }
            else if (obj.behavior.includes('padleft')) {
                rx = '([^\\s.,]+' + obj.text.trim() + ')';
                rxType = '8';
            }

            let flags = 'gmiu';
            if (obj.behavior.includes('exact')) {
                flags = 'gmu';
                rxType = 'X' + rxType;
            }
            allElements[k].innerHTML = allElements[k].innerHTML.replace(new RegExp( '(?<!<[^>]*)(?<!<span.*?glossaryinfo.*?>)(?<!<a.*?>)(?<!<h[0-9].*?>)' + rx + '(?!<\\/span>)(?!<\\/a>)(?!<\\/h[0-9]>)', flags), '<span class="glossaryinfo" data-id="' + obj.id + '">$&</span>')
        }
    }
}

function GetAndLoadIds(element) {
    let elements = document.querySelectorAll('.glossaryinfo');
    let ids = [];
    for(let i = 0; i < elements.length; i++) {
        let id = elements[i].dataset.id;
        if (!ids.includes(id)) {
            ids.push(id);
        }
    }

    if (ids.length > 0) {
        window.noss_glossarypopper = [];
        if (document.querySelector('.glossaryinfo')) {
            let mainElement = document.querySelector('.noss_glossary.sys_parser');
            let glossaries = document.querySelectorAll('.glossaryinfo');
            for(let i = 0; i < glossaries.length; i++) {
                glossaries[i].dataset.goid = 'go' + glossaries[i].dataset.id + '-' + i;
                let targetElement = addGlossary(glossaries[i], mainElement, i);
                addEventHandlers(glossaries[i], targetElement, i);
                glossaries[i].classList.add('init');
            }
        }
    }
}

function showGlossaryPopper(element) {
    document.getElementById(element.dataset.goid).setAttribute('data-show', '');

    // We need to tell Popper to update the tooltip position
    // after we show the tooltip, otherwise it will be incorrect
    window.noss_glossarypopper[element.dataset.goid].update();

    let endpoint = document.body.dataset.nossGlossary;
    endpoint = endpoint.replace('#GID#', element.dataset.id);
    fetch(endpoint, {
        method: 'GET',
    });
}

function hideGlossaryPopper(element) {
    document.getElementById(element.dataset.goid).removeAttribute('data-show');
}
function addEventHandlers(node, targetElement, counter) {
    window.noss_glossarypopper[targetElement.id] = createPopper(node, targetElement, {
        modifiers: [
            {
                name: 'offset',
                options: {
                    offset: [0, 0],
                },
            },
        ],
    });

    const showEvents = ['click'];
    const hideEvents = ['mouseleave', 'blur'];

    showEvents.forEach((eventName) => {
        node.addEventListener(eventName, function (e) {
            showGlossaryPopper(event.target);
        });
    });

    hideEvents.forEach((eventName) => {
        node.addEventListener(eventName, function (e) {
            hideGlossaryPopper(event.target);
        });
    });
}
function addGlossary(node, mainElement, counter) {
    let id = node.dataset.id;
    if (id > 0) {
        let entry = mainElement.querySelector('[id="go' + id + '"]').cloneNode(true);
        entry.id = entry.id + '-' + counter;
        node.appendChild(entry);
        return entry;
    }
}
function CleanupElements(element, invalidTags) {
    if (invalidTags.includes(element.node.tagName)) {
        element.node.innerHTML = element.node.innerHTML.replace(/<span class="glossaryinfo" data-id="\d+">(.*?)<\/span>/g , '$1');
    }

    let children = element.node.children;
    for(let i = 0; i < children.length; i++) {
        if (!children[i].classList.contains('glossaryignore')) {
            CleanupElements({node: children[i], children: []}, invalidTags);
        }
    }
    return element;
}
function initModule() {
    setTimeout(function () {
        let element = document.querySelector('.noss_glossary.sys_parser');
        if (element) {
            let wordlist = JSON.parse(element.dataset.wordlist);
            let mainElement = document.querySelector('main');
            let allElements = GetChildren(mainElement, []);
            ProcessGlossary(allElements, wordlist, []);

            let invalidTags = ['H1', 'H2', 'H3', 'H4', 'H5', 'H6', 'A', 'BUTTON'];
            CleanupElements({node: mainElement, children: []}, invalidTags);

            GetAndLoadIds(element);
        }
    }, 100);
}